const WHO_BG = "https://static.prod-images.emergentagent.com/jobs/3a30fb0f-b7cc-433f-9f20-4e03192e39b7/images/509855276b10801a64ae4cdbfcebf7936a06911668d933427f87ef14f8f0ba0e.png";

export default function WhoWeAre() {
  return (
    <section id="who" className="relative max-w-7xl mx-auto px-6 lg:px-10 py-24" data-testid="who-section">
      <div className="grid grid-cols-12 gap-6">
        <div className="col-span-12 md:col-span-5">
          <p className="overline">Who We Are</p>
          <h2 className="font-display font-light text-4xl lg:text-5xl tracking-tight mt-4">
            A practice that <span className="italic text-[var(--pov-cyan)]">moves</span> before it overthinks.
          </h2>
        </div>
        <div className="col-span-12 md:col-span-7">
          <p className="text-white/65 leading-relaxed">
            We are a consulting practice built for clients who move at the speed of their ambition.
            They arrive with momentum and ambiguity in equal measure. We translate the ambiguity into
            a decision — and the decision into action that closes by month-end. No decks. No
            slide-driven loops. Just the next ten moves, sequenced and shipped.
          </p>
        </div>
      </div>

      <div className="grid grid-cols-12 gap-4 mt-12">
        <div className="col-span-12 md:col-span-7 lg:col-span-8 row-span-2 glass rounded-sm overflow-hidden h-[420px] relative">
          <img src={WHO_BG} alt="Coastal strategy room" className="absolute inset-0 w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-tr from-[#030712] via-[#030712]/40 to-transparent" />
          <div className="relative h-full flex flex-col justify-end p-10">
            <p className="overline mb-3">Operating Principle</p>
            <p className="font-display text-2xl lg:text-3xl tracking-tight max-w-md">
              Decisions made fast, executed without flinching.
            </p>
          </div>
        </div>
        <div className="col-span-12 md:col-span-5 lg:col-span-4 glass rounded-sm p-8">
          <p className="overline mb-3">What We Do</p>
          <p className="text-white/70 text-sm leading-relaxed">
            Strategic positioning, capital structuring, regulatory navigation, brand architecture,
            and the relationship-driven work of putting the right people in the right rooms — fast.
          </p>
        </div>
        <div className="col-span-12 md:col-span-5 lg:col-span-4 glass rounded-sm p-8">
          <p className="overline mb-3">How We Engage</p>
          <p className="text-white/70 text-sm leading-relaxed">
            By referral, by retainer, by intensive. We onboard clients in days — not quarters — and
            we keep the bench tight enough to actually move the deal.
          </p>
        </div>
      </div>
    </section>
  );
}
